import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vanbergehenegouwen.webp';
import screenshot_target from '../../../images/letterfunnel/jeroenvandenhurk.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jeroen van den Hurk"
      firstname="Jeroen"
      companyname="Van Berge Henegouwen"
      competition="Videoworks en ONEXP"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeroenvandenhurk.js